/**
 * Scrollbars that show only while you scroll: a scroll in an element with
 * `.kb-autoscrollbar` (the main panel, the sidebar, the drawer) marks it
 * `.kb-scrolling` until it has been still for a moment. The look is in
 * assets/css/phosphor.css ("Scrollbars").
 */
const IDLE_MS = 900

export default defineNuxtPlugin(() => {
  const timers = new WeakMap<Element, ReturnType<typeof setTimeout>>()

  // Scroll events don't bubble; listening in the capture phase on the
  // document sees every element's
  document.addEventListener('scroll', (event) => {
    const el = event.target
    if (!(el instanceof Element) || !el.classList.contains('kb-autoscrollbar')) return
    el.classList.add('kb-scrolling')
    clearTimeout(timers.get(el))
    timers.set(el, setTimeout(() => el.classList.remove('kb-scrolling'), IDLE_MS))
  }, { capture: true, passive: true })
})
